import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { Type } from '@repo/design-system/components/ui/type';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { css } from '@repo/panda/css';
import { useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useMapDescriptionLinkHandler } from './hooks/useMapDescriptionLinkHandler';
import { LocationContent } from './location-content';
import { getMapDescriptionLinkType, transformMapDescriptionUrl } from './map-description-url';
interface HeroActionDescriptionProps {
  description: string;
  heroActionId: string;
  heroActionName: string;
  variant: 'hero' | 'smartAction';
}
export const HeroActionDescription = t0 => {
  const $ = _c(12);
  const {
    description,
    heroActionId,
    heroActionName,
    variant
  } = t0;
  const analytics = useAnalytics();
  const platform = useHostType();
  let t1;
  if ($[0] !== analytics || $[1] !== heroActionId || $[2] !== heroActionName || $[3] !== platform || $[4] !== variant) {
    t1 = (linkUrl, linkText) => {
      analytics.event("game_map_hero_action_description_link_click", {
        heroActionId,
        heroActionName,
        linkText,
        linkUrl,
        linkType: getMapDescriptionLinkType(linkUrl),
        placement: variant === "hero" ? "sidebar" : "drawer",
        platform
      });
    };
    $[0] = analytics;
    $[1] = heroActionId;
    $[2] = heroActionName;
    $[3] = platform;
    $[4] = variant;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleLinkClick = t1;
  if (variant === "hero") {
    let t2;
    if ($[6] !== description || $[7] !== handleLinkClick) {
      t2 = <LocationContent description={description} textAlign="center" onLinkClick={handleLinkClick} />;
      $[6] = description;
      $[7] = handleLinkClick;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  let t2;
  if ($[9] !== description || $[10] !== handleLinkClick) {
    t2 = <SmartActionDescription description={description} onLinkClick={handleLinkClick} />;
    $[9] = description;
    $[10] = handleLinkClick;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
interface SmartActionDescriptionProps {
  description: string;
  onLinkClick: (href: string, text: string) => void;
}
const SmartActionDescription = t0 => {
  const $ = _c(9);
  const {
    description,
    onLinkClick
  } = t0;
  const handleWandLink = useMapDescriptionLinkHandler();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      width: "full",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["a", "p", "strong", "em", "del", "br"];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [remarkGfm];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== handleWandLink || $[4] !== onLinkClick) {
    t4 = {
      br: _temp,
      a: t5 => {
        const {
          href: t6,
          children,
          ...props
        } = t5;
        const href = t6 === undefined ? "" : t6;
        const isExternal = /^https?:\/\//i.test(href);
        return <a {...props} className={css({
          color: "white",
          textDecoration: "underline",
          _hover: {
            color: "text.secondary",
            cursor: "pointer"
          }
        })} href={href} target={isExternal ? "_blank" : undefined} rel={isExternal ? "noopener noreferrer" : undefined} onClick={event => {
          event.stopPropagation();
          onLinkClick(href, event.currentTarget.textContent?.trim() ?? "");
          if (href.startsWith("wemod://") || href.startsWith("wand://")) {
            event.preventDefault();
            handleWandLink(href);
          }
        }}>{children}</a>;
      },
      p: _temp2,
      strong: _temp3
    };
    $[3] = handleWandLink;
    $[4] = onLinkClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== description || $[7] !== t4) {
    t5 = <Type as="div" variant="body-xs" color="whiteAlpha.70" className={t1}><ReactMarkdown urlTransform={transformMapDescriptionUrl} allowedElements={t2} unwrapDisallowed={true} remarkPlugins={t3} components={t4}>{description}</ReactMarkdown></Type>;
    $[6] = description;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
function _temp() {
  return " ";
}
function _temp2(t0) {
  const {
    children: children_0
  } = t0;
  return <span>{children_0}</span>;
}
function _temp3(t0) {
  const {
    children: children_1,
    ...props_0
  } = t0;
  return <strong {...props_0} className={css({
    fontWeight: "medium"
  })}>{children_1}</strong>;
}